module.exports = __webpack_public_path__ + "img/calendario-popup.d365f542.png";